import { createContext, type ReactNode } from 'react';

export interface MarkdownLinkPickerProps {
  /** The text selected in the editor (may be empty). */
  selectedText: string;
  /** Insert `[text](url)`; the host closes the picker. */
  onInsert: (text: string, url: string) => void;
  onClose: () => void;
}

/**
 * Lets the app supply the "link to a Planosfera item" chooser to every Markdown editor without
 * `shared/ui` knowing about boards, databases or notes. Without a provider the link button keeps
 * its plain `[text](https://)` template.
 */
export const MarkdownLinkPickerContext = createContext<
  ((props: MarkdownLinkPickerProps) => ReactNode) | null
>(null);
